module.exports = __webpack_public_path__ + "img/TelegramIcon.6668b2fd.svg";